import { type ClassValue, clsx } from 'clsx'
import { isValid, parse } from 'date-fns'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function toUtcStartDay(date: Date) {
  return new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0),
  )
}

export function toUtcEndDay(date: Date) {
  return new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59),
  )
}

export const parseFlexibleDate = (dateString: string): Date | null => {
  if (!dateString) return null

  // Try to create a date directly (handles ISO strings)
  let date = new Date(dateString)

  // If invalid, try yyyy-MM-dd format
  if (!isValid(date)) {
    date = parse(dateString, 'yyyy-MM-dd', new Date())
  }

  // If still invalid, try MM/DD/yyyy format with slashes
  if (!isValid(date)) {
    date = parse(dateString, 'MM/dd/yyyy', new Date())
  }

  return isValid(date) ? date : null
}
